(function () {
  if (window.dpMapCountStarted) return;
  window.dpMapCountStarted = true;
  async function refresh() {
    try {
      var response = await fetch('https://previewapi-thgnkdml6q-ew.a.run.app/api/public/map-count', { credentials: 'omit', signal: AbortSignal.timeout(10000) });
      if (!response.ok) throw new Error('Count unavailable');
      var data = await response.json();
      if (!Number.isSafeInteger(data.count) || data.count < 0) return;
      document.querySelectorAll('[data-map-count]').forEach(function (element) {
        element.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en').format(data.count);
        element.closest('[data-map-count-proof]').style.visibility = 'visible';
      });
    } catch (_) { /* No invented fallback count if the API is unavailable. */ }
  }
  refresh();
  setInterval(function () { if (!document.hidden) refresh(); }, 300000);
})();
